import ControllerBase from './../../../../global/js/ControllerBase';

export default class ControllerTeaserRow extends ControllerBase {
    private teasers: HTMLDivElement;


    constructor(element: HTMLElement) {
        super(element);
        this.teasers = this.$references.teasers as HTMLDivElement;
        this.handleGrabScroll();
      
    }
    

    private handleGrabScroll(): void {
        let isDown = false;
        let startX;
        let scrollLeft;

        if(this.teasers){
            this.teasers.addEventListener('mousedown', (e: MouseEvent) => {
                isDown = true;
                this.teasers.classList.add('active');
                startX = e.pageX - this.teasers.offsetLeft;
                scrollLeft = this.teasers.scrollLeft;
            });

            this.teasers.addEventListener('mouseleave', () => {
                isDown = false;
                this.teasers.classList.remove('active');
            });

            this.teasers.addEventListener('mouseup', () => {
                isDown = false;
                this.teasers.classList.remove('active');
            });

            this.teasers.addEventListener('mousemove', (e: MouseEvent) => {
                if(!isDown) return;
                e.preventDefault();
                const x = e.pageX - this.teasers.offsetLeft;
                const walk = (x - startX) * 3; //scroll-fast
                this.teasers.scrollLeft = scrollLeft - walk;
            });
    }
        
    }
  
}